import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-subtitle-2" }
const _hoisted_2 = {
  key: 1,
  class: "text-caption text-medium-emphasis"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "text-caption text-medium-emphasis mb-2" }
const _hoisted_5 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_6 = { class: "factory-step-pre" }
const _hoisted_7 = {
  key: 3,
  class: "mt-3"
}
const _hoisted_8 = { class: "text-caption" }
const _hoisted_9 = {
  key: 0,
  class: "mt-2 factory-step-errors"
}
const _hoisted_10 = { class: "d-flex justify-end mt-3 ga-2" }
const _hoisted_11 = {
  key: 0,
  class: "factory-step-children"
}

import { computed, ref } from 'vue'
import FormattingCard from '@/components/cards/FormattingCard.vue'
import ToolEventsPanel from '@/components/sub/ToolEventsPanel.vue'
import type { FactoryStepRunDisplay, FactoryStepRunRecord } from '@/types/factories'


export default /*@__PURE__*/_defineComponent({
  __name: 'FactoryStepRunCard',
  props: {
    stepRun: {}
  },
  emits: ["open-workflow", "open-chat"],
  setup(__props: any) {



const props = __props

const expanded = ref(props.stepRun.status === 'running')

const collapsedTitle = computed(() => {
  const ordinal = String(props.stepRun.stepIndex + 1)
  const invokedName = props.stepRun.invoked.agentName || props.stepRun.invoked.workflowName
  if (invokedName && invokedName.trim()) {
    return `${ordinal} ${invokedName}`.trim()
  }

  const genericStepName = new RegExp(`^step\\s+${ordinal}$`, 'i')
  if (genericStepName.test(props.stepRun.stepName.trim())) {
    return ordinal
  }

  return `${ordinal} ${props.stepRun.stepName}`.trim()
})

const statusIcon = computed(() => {
  switch (props.stepRun.status) {
    case 'queued': return 'mdi-clock-outline'
    case 'running': return 'mdi-loading mdi-spin'
    case 'completed': return 'mdi-check-circle'
    case 'cancelled': return 'mdi-cancel'
    case 'error': return 'mdi-alert-circle'
    default: return 'mdi-circle-outline'
  }
})

const statusColor = computed(() => {
  switch (props.stepRun.status) {
    case 'queued': return 'grey'
    case 'running': return 'primary'
    case 'completed': return 'success'
    case 'cancelled': return 'warning'
    case 'error': return 'error'
    default: return 'grey'
  }
})

const statusClass = computed(() => {
  if (props.stepRun.status === 'running') return 'border-primary'
  if (props.stepRun.status === 'cancelled') return 'border-warning'
  if (props.stepRun.status === 'error') return 'border-error'
  return ''
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_FactoryStepRunCard = _resolveComponent("FactoryStepRunCard", true)!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_card, {
      variant: "outlined",
      class: _normalizeClass(["mb-2", statusClass.value])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, { class: "d-flex align-center py-2 px-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              icon: statusIcon.value,
              color: statusColor.value,
              size: "small",
              class: "mr-2"
            }, null, 8, ["icon", "color"]),
            _createElementVNode("span", _hoisted_1, _toDisplayString(collapsedTitle.value), 1),
            (_ctx.stepRun.status !== 'queued')
              ? (_openBlock(), _createBlock(_component_v_chip, {
                  key: 0,
                  size: "x-small",
                  density: "compact",
                  color: statusColor.value,
                  class: "ml-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.stepRun.status), 1)
                  ]),
                  _: 1
                }, 8, ["color"]))
              : _createCommentVNode("", true),
            _createVNode(_component_v_chip, {
              size: "x-small",
              density: "compact",
              class: "ml-2",
              variant: "tonal"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.stepRun.invoked.kind), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_spacer),
            (_ctx.stepRun.usage)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.stepRun.usage.promptTokens || 0) + " prompt | " + _toDisplayString(_ctx.stepRun.usage.completionTokens || 0) + " completion | " + _toDisplayString(_ctx.stepRun.usage.totalTokens || 0) + " total ", 1))
              : _createCommentVNode("", true),
            _createVNode(_component_v_btn, {
              size: "x-small",
              density: "compact",
              variant: "text",
              icon: expanded.value ? 'mdi-chevron-up' : 'mdi-chevron-down',
              onClick: _cache[0] || (_cache[0] = ($event: any) => (expanded.value = !expanded.value))
            }, null, 8, ["icon"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_expand_transition, null, {
          default: _withCtx(() => [
            (expanded.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_card_text, { class: "pa-2" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, " Sequence " + _toDisplayString(_ctx.stepRun.sequence) + " · Triggered by " + _toDisplayString(_ctx.stepRun.triggeredBy), 1),
                      (_ctx.stepRun.input)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-overline mb-1" }, "Input", -1)),
                            _createElementVNode("pre", _hoisted_6, _toDisplayString(_ctx.stepRun.input), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.stepRun.toolEvents.length > 0)
                        ? (_openBlock(), _createBlock(ToolEventsPanel, {
                            key: 1,
                            "tool-events": _ctx.stepRun.toolEvents,
                            "show-activity": _ctx.stepRun.status === 'running',
                            compact: ""
                          }, null, 8, ["tool-events", "show-activity"]))
                        : _createCommentVNode("", true),
                      (_ctx.stepRun.output)
                        ? (_openBlock(), _createBlock(FormattingCard, {
                            key: 2,
                            content: _ctx.stepRun.output,
                            expanded: 'true',
                            title: null,
                            streaming: _ctx.stepRun.status === 'running'
                          }, null, 8, ["content", "streaming"]))
                        : _createCommentVNode("", true),
                      (_ctx.stepRun.validation)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-overline mb-1" }, "Validation", -1)),
                            _createVNode(_component_v_chip, {
                              size: "x-small",
                              density: "compact",
                              class: "mr-2",
                              color: _ctx.stepRun.validation.finalOutcome === 'pass' ? 'success' : 'error'
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.stepRun.validation.finalOutcome), 1)
                              ]),
                              _: 1
                            }, 8, ["color"]),
                            _createElementVNode("span", _hoisted_8, " initial " + _toDisplayString(_ctx.stepRun.validation.initialOutcome) + " · repairs " + _toDisplayString(_ctx.stepRun.validation.repairAttempts), 1),
                            (_ctx.stepRun.validation.errors?.length)
                              ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stepRun.validation.errors, (error) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: `${error.path}-${error.message}`
                                    }, _toDisplayString(error.path || '(root)') + ": " + _toDisplayString(error.message), 1))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_10, [
                        (_ctx.stepRun.workflowRunId && _ctx.stepRun.invoked.workflowConfigId)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              size: "small",
                              density: "compact",
                              variant: "text",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('open-workflow', _ctx.stepRun)))
                            }, {
                              default: _withCtx(() => _cache[7] || (_cache[7] = [
                                _createTextVNode(" Open workflow run ")
                              ])),
                              _: 1,
                              __: [7]
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.stepRun.chatId)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 1,
                              size: "small",
                              density: "compact",
                              variant: "text",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('open-chat', _ctx.stepRun)))
                            }, {
                              default: _withCtx(() => _cache[8] || (_cache[8] = [
                                _createTextVNode(" Open chat ")
                              ])),
                              _: 1,
                              __: [8]
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class"]),
    (_ctx.stepRun.children?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stepRun.children, (child) => {
            return (_openBlock(), _createBlock(_component_FactoryStepRunCard, {
              key: child.stepRunId,
              "step-run": child,
              onOpenWorkflow: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('open-workflow', $event))),
              onOpenChat: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('open-chat', $event)))
            }, null, 8, ["step-run"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})